export default {
  details: 'ดูรายละเอียดและตัวอย่าง',
  current: 'ตามตัวเลือกปัจจุบัน',
  example: 'ตัวอย่างสมมติ',
  holidayColumn: 'การนับวันหยุด',
  columnTitles: {
    tenureStart: 'อายุงานเริ่มต้น',
    tenureEnd: 'อายุงานสิ้นสุด',
    entitlementDays: 'จำนวนวันสิทธิ์',
    isEntitleBlockLeave: 'สิทธิ์ Block Leave',
    blockLeaveReference: 'ลำดับ Block Leave'
  },
  general: {
    summary:
      'กำหนดข้อมูลประเภทลาและกลุ่มพนักงานที่ใช้ได้ จากนั้นตั้งเงื่อนไขและสิทธิ์ในส่วนถัดไป'
  },
  company: {
    summary:
      'บริษัทเจ้าของประเภทลานี้ แสดงตามบริษัทที่เลือกเข้ามาตั้งค่า และแก้ในช่องนี้ไม่ได้'
  },
  status: {
    summary: 'กำหนดว่าประเภทลานี้เปิดให้ใช้งานหรือไม่',
    choices: [
      {
        value: 1,
        title: 'ใช้งาน',
        description:
          'เปิดใช้ประเภทลานี้ โดยพนักงานยังต้องผ่านเงื่อนไขสิทธิ์และกลุ่มพนักงานที่กำหนด'
      },
      {
        value: -1,
        title: 'ไม่ใช้งาน',
        description: 'ปิดการใช้งานประเภทลานี้ โดยไม่ได้ลบประวัติรายการลาเดิม'
      }
    ]
  },
  code: {
    summary:
      'รหัสสำหรับอ้างอิงประเภทลา ควรใช้รหัสที่แยกจากประเภทลาอื่นได้ชัดเจน'
  },
  nameTH: { summary: 'ชื่อประเภทลาที่แสดงเมื่อใช้ภาษาไทย เช่น ลาพักร้อน' },
  nameEN: {
    summary: 'ชื่อประเภทลาที่แสดงเมื่อใช้ภาษาอังกฤษ เช่น Annual Leave'
  },
  leaveTypeColor: {
    summary: 'สีที่ใช้แยกประเภทลาในหน้าที่แสดงสี เช่น ปฏิทิน'
  },
  gender: {
    summary: 'เลือกเพศของพนักงานที่สามารถใช้ประเภทลานี้ ตามข้อมูลพนักงานในระบบ',
    choices: [
      {
        value: 2,
        title: 'ชาย',
        description: 'ใช้กับพนักงานที่มีข้อมูลเพศเป็นชาย'
      },
      {
        value: 3,
        title: 'หญิง',
        description: 'ใช้กับพนักงานที่มีข้อมูลเพศเป็นหญิง'
      },
      { value: 1, title: 'ทุกเพศ', description: 'ไม่จำกัดสิทธิ์ตามเพศ' }
    ]
  },
  officerType: {
    summary: 'เลือกกลุ่มพนักงานที่ได้รับสิทธิ์ตามสถานะพนักงานในระบบ',
    choices: [
      {
        value: 1,
        title: 'พนักงานทั้งหมด',
        description: 'ครอบคลุมทุกกลุ่มสถานะพนักงาน'
      },
      {
        value: 2,
        title: 'พนักงานปัจจุบัน',
        description: 'ใช้กับพนักงานที่ระบบระบุสถานะเป็น “พนักงานปัจจุบัน”'
      },
      {
        value: 3,
        title: 'พนักงานใหม่',
        description: 'ใช้กับพนักงานที่ระบบระบุสถานะเป็น “พนักงานใหม่”'
      },
      {
        value: 4,
        title: 'พนักงานทดลองงาน',
        description: 'ใช้กับพนักงานที่ระบบระบุสถานะเป็น “พนักงานทดลองงาน”'
      },
      {
        value: 5,
        title: 'พนักงานใหม่และทดลองงาน',
        description: 'ใช้กับทั้งพนักงานใหม่และพนักงานทดลองงานตามสถานะในระบบ'
      }
    ]
  },
  leaveSetting: {
    summary:
      'จำกัดจำนวนครั้งที่ขอลา แยกจากระยะเวลาวัน/ชั่วโมง/นาที เช่น ลา 3 วันในคำขอเดียวคือ 1 ครั้ง',
    choices: [
      {
        value: 1,
        title: 'สูงสุดตลอดอายุงาน',
        description: 'ใช้เพดานจำนวนครั้งสะสมตลอดอายุงาน',
        example: 'ตั้ง 3 ครั้ง หมายถึงขอลาประเภทนี้ได้ไม่เกิน 3 ครั้งสะสม'
      },
      {
        value: 2,
        title: 'สูงสุดต่อปี',
        description: 'ใช้เพดานจำนวนครั้งในปีของรอบสิทธิ์ลา',
        example: 'ตั้ง 2 ครั้งต่อปี แยกจากจำนวนวันสิทธิ์ที่มีในปีนั้น'
      },
      {
        value: 4,
        title: 'ไม่ระบุเพดานจำนวนครั้ง',
        description:
          'ไม่ใช้เพดานจำนวนครั้งสองช่องนี้ แต่เงื่อนไขระยะเวลาและสิทธิ์อื่นยังใช้ตามเดิม'
      }
    ]
  },
  maxLeaveOverLifeTime: {
    summary:
      'จำนวนครั้งสูงสุดสะสมตลอดอายุงาน ใช้เมื่อเลือกเพดานตลอดอายุงาน ไม่ใช่จำนวนวันลา'
  },
  maxLeavePerYear: {
    summary:
      'จำนวนครั้งสูงสุดต่อปีของรอบสิทธิ์ลา ใช้เมื่อเลือกเพดานต่อปี ไม่ใช่จำนวนวันลา'
  },
  minLeaveDayPerTime: {
    summary:
      'ระยะเวลาลาขั้นต่ำของคำขอหนึ่งรายการ กรอกจำนวนและเลือกหน่วยควบคู่กัน เช่น อย่างน้อย 2 ชั่วโมง',
    choices: [
      {
        value: 1,
        title: 'วัน',
        description: 'ใช้จำนวนวัน โดยแปลงตามชั่วโมงทำงานต่อวันของระบบ'
      },
      {
        value: 2,
        title: 'ชั่วโมง',
        description: 'ใช้จำนวนชั่วโมง เช่น 2 ชั่วโมง = 120 นาที'
      },
      {
        value: 3,
        title: 'นาที',
        description: 'ใช้จำนวนเวลาที่ละเอียดระดับนาที เช่น 30 นาที'
      }
    ]
  },
  maxLeaveDayPerTime: {
    summary:
      'ระยะเวลาลาสูงสุดของคำขอหนึ่งรายการ กรอกจำนวนและหน่วย ไม่ใช่เพดานจำนวนครั้งหรือสิทธิ์รวม',
    choices: [
      {
        value: 1,
        title: 'วัน',
        description:
          'จำกัดเป็นวันตามชั่วโมงทำงานต่อวัน เช่น ไม่เกิน 5 วันต่อคำขอ'
      },
      {
        value: 2,
        title: 'ชั่วโมง',
        description: 'จำกัดเป็นชั่วโมง เช่น ไม่เกิน 4 ชั่วโมงต่อคำขอ'
      },
      {
        value: 3,
        title: 'นาที',
        description: 'จำกัดเป็นนาที เช่น ไม่เกิน 90 นาทีต่อคำขอ'
      }
    ]
  },
  blockLeaveType: {
    summary:
      'กำหนดว่าจะเปิดใช้การลาเป็นช่วง Block Leave หรือไม่ โดยมีช่วงวันที่และจำนวนวันขั้นต่ำของแต่ละช่วง',
    choices: [
      {
        value: true,
        title: 'เลือก',
        description:
          'เปิดใช้ Block Leave และกำหนดช่วงด้านล่าง จากนั้นผูกลำดับช่วงกับตารางสิทธิ์'
      },
      {
        value: false,
        title: 'ไม่เลือก',
        description:
          'ไม่เปิดใช้ Block Leave ค่าตารางไม่ได้เป็นการอนุญาตให้ใช้ Block Leave จนกว่าจะเปิด'
      }
    ]
  },
  blockGeneral: {
    summary:
      'แต่ละแถวคือช่วง Block Leave หนึ่งช่วง คำขอต้องอยู่ภายในช่วงที่ตรงกันเพียงช่วงเดียว ปุ่ม +/− เพิ่มหรือลบช่วง'
  },
  blockSequence: {
    summary:
      'เลขอ้างอิงของช่วง ใช้ผูกกับสิทธิ์ Block Leave ในตารางอายุงานด้านล่าง'
  },
  periodStart: { summary: 'วันและเดือนเริ่มต้นของช่วงที่กำหนด เช่น 1 เมษายน' },
  periodEnd: { summary: 'วันและเดือนสิ้นสุดของช่วงที่กำหนด เช่น 30 มิถุนายน' },
  blockMinimum: {
    summary: 'จำนวนวันลาขั้นต่ำของ Block Leave ในช่วงนี้ ไม่ใช่จำนวนครั้งที่ลา'
  },
  includeDayOff: {
    summary:
      'เลือกวิธีนับวันหยุดสำหรับ Block Leave ในแถวนี้ ใช้แทนวิธีนับวันของการลาปกติ',
    choices: [
      {
        value: true,
        title: 'นับรวมวันหยุด',
        description: 'นับรวมวันหยุดประจำสัปดาห์และวันหยุดนักขัตฤกษ์',
        example: 'ช่วง 5 วันมีวันหยุด 2 วัน นับลา 5 วัน'
      },
      {
        value: false,
        title: 'ไม่นับรวมวันหยุด',
        description: 'ไม่นับวันหยุดประจำสัปดาห์และวันหยุดนักขัตฤกษ์',
        example: 'ช่วง 5 วันมีวันหยุดไม่ซ้ำกัน 2 วัน นับลา 3 วัน'
      }
    ]
  },
  workTimeCalculationType: {
    summary:
      'เลือกวันที่เริ่มนับอายุงาน เพื่อเลือกสิทธิ์จากตารางและคำนวณสัดส่วน แยกจากวันที่ให้สิทธิ์',
    choices: [
      {
        value: 1,
        title: 'วันที่เริ่มงาน',
        description: 'เริ่มนับอายุงานจากวันที่เริ่มงานที่บันทึกในระบบ'
      },
      {
        value: 2,
        title: 'วันที่ผ่านทดลองงาน',
        description: 'เริ่มนับอายุงานจากวันที่ผ่านทดลองงานที่บันทึกในระบบ'
      }
    ]
  },
  permissionLeave: {
    summary: 'เลือกช่วงเวลาหรือเหตุการณ์ที่ใช้ให้สิทธิ์ลา',
    choices: [
      {
        value: 1,
        title: 'รอบการลา',
        description:
          'ให้สิทธิ์ตามรอบการลาที่กำหนด เช่น รอบปฏิทินหรือรอบกำหนดเอง',
        example: 'รอบปฏิทินเริ่ม 1 มกราคม ส่วนรอบกำหนดเองอาจเริ่ม 1 เมษายน'
      },
      {
        value: 2,
        title: 'ณ วันที่เริ่มงาน',
        description:
          'ใช้วันที่เริ่มงานเป็นเงื่อนไขเริ่มได้รับสิทธิ์ ต้องมีวันที่เริ่มงานที่ถึงกำหนดแล้ว',
        example:
          'เริ่มงาน 1 เมษายน ใช้วันที่นี้เป็นเงื่อนไข ไม่ใช่วันผ่านทดลองงาน'
      },
      {
        value: 3,
        title: 'ณ วันที่ผ่านทดลองงาน',
        description: 'เริ่มมีสิทธิ์เมื่อถึงวันที่ผ่านทดลองงานที่บันทึกไว้',
        example:
          'เริ่มงานเมษายน ผ่านทดลองงานกรกฎาคม ใช้วันที่ผ่านทดลองงานเป็นเงื่อนไข'
      },
      {
        value: 4,
        title: 'ทุกต้นเดือน',
        description:
          'ประมวลผลให้สิทธิ์ในวันแรกของเดือน จำนวนที่ได้ขึ้นกับตารางและวิธีคำนวณ ไม่ได้หมายถึงหารสิทธิ์รายปีด้วย 12 เสมอ'
      },
      {
        value: 5,
        title: 'ทุกสิ้นเดือน',
        description:
          'ประมวลผลให้สิทธิ์ในวันสุดท้ายของเดือน ต่างจากต้นเดือนที่วันที่ให้สิทธิ์'
      },
      {
        value: 7,
        title: 'เริ่มลาครั้งแรก',
        description:
          'ใช้สิทธิ์แบบเริ่มลาครั้งแรก พร้อมจำนวนวันสำหรับจำกัดระยะเวลาของคำขอครั้งแรก ไม่ใช่จำนวนวันที่รอหลังเริ่มงาน',
        example:
          'กรอก 3 วัน คำขอครั้งแรกต้องไม่เกิน 3 วัน โดยยังต้องผ่านเงื่อนไขอื่น'
      }
    ]
  },
  permissionLeaveDay: {
    summary:
      'ใช้กับ “เริ่มลาครั้งแรก”: จำกัดระยะเวลาคำขอครั้งแรก แบบรายวันนับตั้งแต่วันเริ่มถึงวันสิ้นสุดรวมวันหยุด แบบชั่วโมงแปลงเป็นวันตามชั่วโมงทำงานต่อวัน ไม่ใช่ระยะเวลารอรับสิทธิ์'
  },
  permissionCalculation: {
    summary:
      'เลือกวิธีคำนวณจำนวนสิทธิ์จากตารางอายุงาน แยกจากตัวเลือกว่ารับสิทธิ์เมื่อไร',
    choices: [
      {
        value: 1,
        title: 'เต็มจำนวน',
        description:
          'ใช้จำนวนสิทธิ์จากตารางที่เข้าเงื่อนไข โดยไม่ลดตามสัดส่วนอายุงาน',
        example: 'สิทธิ์ตามตาราง 10 วัน ใช้ฐาน 10 วัน'
      },
      {
        value: 2,
        title: 'ตามสัดส่วน',
        description:
          'เมื่ออายุงานที่คำนวณยังไม่ถึง 12 เดือน ใช้จำนวนวันจากวันเริ่มนับถึงวันอ้างอิง ÷ 365 × สิทธิ์ตามตาราง แล้วใช้วิธีปัดเศษที่เลือก',
        example:
          'ฐาน 10 วัน ช่วงคำนวณ 146 วัน ได้ 10 × 146 ÷ 365 = 4 วัน ก่อนปัดเศษ'
      }
    ]
  },
  monthRound: {
    summary:
      'ปรับวันเริ่มนับอายุงานตามวันที่เริ่มนับตกในช่วงใดของตาราง ช่องนี้เปิดให้แก้เมื่อเลือกคำนวณตามสัดส่วน',
    choices: [
      {
        value: 1,
        title: 'ไม่ปัดเศษเดือน',
        description: 'ใช้วันเริ่มนับอายุงานเดิม ไม่ปรับด้วยตารางนี้'
      },
      {
        value: 2,
        title: 'ปัดเศษเดือน',
        description:
          'หากเลขวันที่เริ่มนับอยู่ในช่วงที่กำหนด จะเลื่อนวันเริ่มนับย้อนหลังตามจำนวนวันในช่องปัดเศษ',
        example:
          'วันที่เริ่มนับคือวันที่ 10 ตรงช่วง 1–15 และกำหนด 5 วัน ระบบเลื่อนวันเริ่มนับย้อนหลัง 5 วัน'
      }
    ]
  },
  rowOrder: { summary: 'ลำดับแถว ปุ่ม +/− ใช้เพิ่มหรือลบเงื่อนไขของตารางนี้' },
  roundStart: {
    summary:
      'เลขวันที่เริ่มช่วง เช่น 1 หมายถึงวันที่ 1 ของเดือน ไม่ใช่จำนวนวันลา'
  },
  roundEnd: {
    summary: 'เลขวันที่สิ้นสุดช่วง เช่น 15 หมายถึงวันที่ 15 ของเดือน'
  },
  roundDays: {
    summary:
      'จำนวนวันสำหรับเลื่อนวันเริ่มนับอายุงานย้อนหลังเมื่อเข้าเงื่อนไขช่วงนี้'
  },
  roundType: {
    summary: 'ใช้ปัดจำนวนวันสิทธิ์ที่คำนวณได้ โดยเฉพาะการคำนวณตามสัดส่วน',
    choices: [
      {
        value: 1,
        title: 'ไม่ปัดเศษ',
        description: 'เก็บค่าที่คำนวณได้',
        example: '2.2 วันคงเป็น 2.2 วัน'
      },
      {
        value: 2,
        title: 'ปัดลง',
        description: 'ตัดส่วนทศนิยมให้เหลือจำนวนวันเต็ม',
        example: '2.8 วันเป็น 2 วัน'
      },
      {
        value: 7,
        title: 'ตามนโยบาย',
        description:
          'ปัดส่วนทศนิยมให้เหลือ 2 ตำแหน่งก่อนเทียบเกณฑ์: ต่ำกว่า 0.5 ปรับเป็นครึ่งวัน เท่ากับ 0.5 คงค่าเดิม และเกิน 0.5 ปัดขึ้นเป็นวันเต็ม',
        example: '2 → 2.5 วัน, 2.2 → 2.5 วัน, 2.5 → 2.5 วัน และ 2.8 → 3 วัน'
      }
    ]
  },
  leaveDayCalculationType: {
    summary:
      'เลือกว่าวันหยุดชนิดใดนับเป็นวันลา สำหรับคำขอปกติ โดยใช้ปฏิทินวันหยุดและตารางทำงานของพนักงาน',
    choices: [
      {
        value: 1,
        title: 'ไม่รวมวันหยุด',
        description: 'ไม่นับวันหยุดประจำสัปดาห์และวันหยุดนักขัตฤกษ์',
        example: 'ช่วง 5 วันมีวันหยุดไม่ซ้ำกัน 2 วัน นับลา 3 วัน'
      },
      {
        value: 2,
        title: 'รวมวันหยุดประจำสัปดาห์',
        description: 'นับวันหยุดประจำสัปดาห์ แต่ไม่นับวันหยุดนักขัตฤกษ์',
        example:
          'ช่วง 5 วันมีวันหยุดประจำสัปดาห์ 1 วันและนักขัตฤกษ์อีก 1 วัน นับลา 4 วัน'
      },
      {
        value: 3,
        title: 'รวมวันหยุดทั้งหมด',
        description: 'นับทั้งวันหยุดประจำสัปดาห์และวันหยุดนักขัตฤกษ์',
        example: 'ช่วง 5 วัน นับลา 5 วัน'
      }
    ]
  },
  entitlementTable: {
    summary:
      'กำหนดสิทธิ์แยกตามหน่วยงาน ตำแหน่ง ระดับ และอายุงาน แต่ละกลุ่มมีเงื่อนไขการยกยอดของตนเอง ปุ่ม +/− เพิ่มหรือลบกลุ่ม/ช่วงอายุงาน'
  },
  organize: {
    summary: 'เลือกหน่วยงานตามโครงสร้างองค์กรที่ใช้ตารางสิทธิ์กลุ่มนี้'
  },
  position: {
    summary:
      'เลือกตำแหน่งงานที่ใช้สิทธิ์กลุ่มนี้ ใช้ร่วมกับหน่วยงานและระดับงาน ไม่ใช่ตำแหน่งผู้อนุมัติ'
  },
  level: {
    summary: 'เลือกระดับงานที่ใช้สิทธิ์กลุ่มนี้ ใช้ร่วมกับหน่วยงานและตำแหน่งงาน'
  },
  tenureStart: {
    summary:
      'อายุงานเริ่มต้น: กรอกปีและเดือนร่วมกัน เช่น 1 ปี 6 เดือน = 18 เดือน นับจากวันที่เริ่มนับอายุงานที่เลือก'
  },
  tenureEnd: {
    summary:
      'อายุงานสิ้นสุด: บันทึกปีและเดือนปลายช่วง ไม่ใช่วันที่หมดสิทธิ์ การให้สิทธิ์ปัจจุบันใช้เกณฑ์อายุงานเริ่มต้นของแถวที่เข้าเงื่อนไข'
  },
  entitlementDays: {
    summary:
      'จำนวนวันสิทธิ์พื้นฐานของแถวนี้เมื่อถึงเกณฑ์อายุงานเริ่มต้น เช่น 10 วัน ใช้ร่วมกับหลักเกณฑ์ให้สิทธิ์ วิธีคำนวณ และการปัดเศษ'
  },
  isEntitleBlockLeave: {
    summary: 'กำหนดว่าช่วงอายุงานนี้ผูกกับ Block Leave หรือไม่',
    choices: [
      {
        value: true,
        title: 'เลือกได้รับสิทธิ์',
        description: 'ผูกกับช่วง Block Leave โดยกรอกเลขลำดับช่วงในช่องถัดไป'
      },
      {
        value: false,
        title: 'ไม่เลือก',
        description: 'ไม่ผูกช่วงอายุงานนี้กับ Block Leave'
      }
    ]
  },
  blockLeaveReference: {
    summary:
      'กรอกเลขลำดับ Block Leave จากตารางด้านบน เช่น 2 คือช่วงลำดับที่ 2 ค่านี้เป็นเลขอ้างอิง ไม่ใช่จำนวนวัน แม้ข้อความข้างช่องเดิมแสดง “วัน”'
  },
  forwardType: {
    summary:
      'กำหนดวิธีนำสิทธิ์คงเหลือจากรอบก่อนมาใช้ในรอบใหม่ แยกจากการอนุญาตให้ขอลาข้ามปี',
    choices: [
      {
        value: 1,
        title: 'ไม่ยกยอด',
        description: 'ไม่โอนสิทธิ์คงเหลือจากรอบก่อน'
      },
      {
        value: 2,
        title: 'ยกยอดทั้งหมด',
        description: 'โอนสิทธิ์คงเหลือทั้งหมด',
        example: 'เหลือ 4 วัน ยกยอด 4 วัน'
      },
      {
        value: 3,
        title: 'ยกยอดสะสม',
        description: 'โอนสิทธิ์คงเหลือได้ไม่เกินเพดานวันและชั่วโมงที่กรอก',
        example:
          'เหลือ 4 วัน ตั้งเพดาน 2 วัน 4 ชั่วโมง ยกยอดไม่เกิน 2 วัน 4 ชั่วโมง'
      }
    ]
  },
  forwardLimit: {
    summary:
      'เพดานยกยอดรวม = จำนวนวัน + จำนวนชั่วโมง เช่น 2 วันและ 4 ชั่วโมงเป็นเพดานเดียว วันแปลงตามชั่วโมงทำงานต่อวัน ไม่ใช่สองเพดานแยกกัน'
  },
  expireType: {
    summary: 'กำหนดช่วงที่ใช้สิทธิ์ยกยอดได้ ไม่ใช่ช่วงห้ามลาหรือรอบการลาใหม่',
    choices: [
      {
        value: 1,
        title: 'ใช้สิทธิ์ได้ทุกวัน',
        description: 'ไม่กำหนดช่วงวัน/เดือนเฉพาะสำหรับใช้สิทธิ์ยกยอด'
      },
      {
        value: 2,
        title: 'ใช้ตามวันที่กำหนด',
        description: 'ใช้สิทธิ์ยกยอดภายในช่วงวัน/เดือนที่กำหนดด้านล่าง',
        example: 'ตั้ง 1 มกราคมถึง 31 มีนาคม ใช้ยอดยกมาในช่วงนี้'
      }
    ]
  },
  approvalSettings: {
    summary:
      'กำหนดการลาเกินสิทธิ์และช่วงวันที่ห้ามลา เงื่อนไขอื่นของประเภทลายังใช้ร่วมกัน'
  },
  isAllowOverdue: {
    summary:
      'กำหนดว่าจะอนุญาตให้ระยะเวลาที่ขอลาเกินยอดสิทธิ์คงเหลือหรือไม่ ไม่ใช่การลาข้ามปี',
    choices: [
      {
        value: true,
        title: 'อนุญาต',
        description:
          'อนุญาตให้ลาเกินยอดสิทธิ์ โดยยังตรวจเงื่อนไขอื่น เช่น จำนวนครั้งและระยะเวลาต่อคำขอ'
      },
      {
        value: false,
        title: 'ไม่อนุญาต',
        description:
          'คำขอปกติต้องมีสิทธิ์เพียงพอ หากเปิดลาฉุกเฉินจะใช้เงื่อนไขฉุกเฉินร่วมด้วย'
      }
    ]
  },
  isActiveForbiddenDate: {
    summary:
      'เปิดหรือปิดการตรวจช่วงห้ามลา โดยกำหนดวันและเดือนเริ่ม–สิ้นสุดได้หลายช่วง',
    choices: [
      {
        value: true,
        title: 'เลือก',
        description: 'ใช้ช่วงวันที่ด้านล่างเพื่อตรวจคำขอที่ทับช่วงห้ามลา'
      },
      {
        value: false,
        title: 'ไม่เลือก',
        description: 'ไม่ใช้ช่วงห้ามลาจากตารางนี้ ช่องวัน/เดือนจะไม่เปิดให้แก้'
      }
    ]
  },
  prospectLeave: {
    summary:
      'กำหนดจำนวนวันล่วงหน้าขั้นต่ำเป็นวันปฏิทิน โดยนับวันยื่นคำขอเป็นวันที่ 1',
    choices: [
      {
        value: false,
        title: 'ไม่เลือก',
        description: 'ไม่ใช้ข้อกำหนดจำนวนวันล่วงหน้าจากช่องนี้'
      },
      {
        value: true,
        title: 'เลือก',
        description:
          'วันเริ่มและสิ้นสุดลาต้องครบจำนวนวันล่วงหน้าที่กำหนด ยกเว้นคำขอย้อนหลังที่ผ่านเงื่อนไขย้อนหลัง',
        example:
          'ยื่น 1 เมษายน กำหนด 3 วัน เริ่มลาได้ตั้งแต่ 3 เมษายนตามเงื่อนไขนี้'
      }
    ]
  },
  retrospectLeave: {
    summary: 'กำหนดขอบเขตวันย้อนหลังจากวันยื่นคำขอ โดยใช้วันปฏิทิน',
    choices: [
      {
        value: false,
        title: 'ไม่เลือก',
        description:
          'ไม่ใช้ขอบเขตจำนวนวันย้อนหลังจากช่องนี้ เงื่อนไขวันที่อื่นยังใช้ตามเดิม'
      },
      {
        value: true,
        title: 'เลือก',
        description:
          'กรอกจำนวนวันย้อนหลังที่ยอมรับ วันเริ่มและสิ้นสุดลาต้องไม่ก่อนวันยื่นลบจำนวนนี้',
        example: 'ยื่นวันที่ 10 กรอก 3 วัน ย้อนหลังได้ถึงวันที่ 7'
      }
    ]
  },
  isRequireAttachment: {
    summary:
      'กำหนดว่าพนักงานต้องแนบเอกสารประกอบคำขอลาหรือไม่ ช่องนี้ไม่ได้กำหนดขนาดหรือชนิดไฟล์',
    choices: [
      { value: true, title: 'บังคับ', description: 'คำขอต้องมีไฟล์แนบประกอบ' },
      {
        value: false,
        title: 'ไม่บังคับ',
        description: 'ไม่บังคับแนบเอกสารจากการตั้งค่านี้'
      }
    ]
  },
  isRequireReason: {
    summary: 'กำหนดว่าต้องกรอกเหตุผลก่อนส่งคำขอลาหรือไม่',
    choices: [
      { value: true, title: 'บังคับ', description: 'คำขอต้องมีเหตุผลการลา' },
      {
        value: false,
        title: 'ไม่บังคับ',
        description: 'เหตุผลไม่เป็นข้อมูลบังคับจากการตั้งค่านี้'
      }
    ]
  },
  reasonTextHeader: {
    summary:
      'ข้อความแนะนำที่แสดงในช่องเหตุผล เช่น กรุณาระบุเหตุผลและข้อมูลประกอบ เป็นข้อความช่วยกรอก ไม่ใช่เหตุผลของคำขอจริง'
  },
  isAllowOverLeave: {
    summary:
      'กำหนดการใช้สิทธิ์เพื่อขอลาในปีถัดไป แยกจากการโอนยอดสิทธิ์คงเหลือไปยังรอบใหม่',
    choices: [
      {
        value: true,
        title: 'อนุญาต',
        description:
          'เปิดการขอลาข้ามปีตามสิทธิ์และรอบที่ระบบรองรับ ไม่ได้ทำให้สิทธิ์คงเหลือถูกยกยอดโดยอัตโนมัติ'
      },
      {
        value: false,
        title: 'ไม่อนุญาต',
        description:
          'ไม่เปิดการขอลาข้ามปีจากการตั้งค่านี้ การยกยอดยังเป็นอีกเงื่อนไขหนึ่ง'
      }
    ]
  },
  isAllowUrgentLeave: {
    summary:
      'เปิดการขอลาฉุกเฉิน ซึ่งมีผลต่อการตรวจยอดสิทธิ์ ไม่ได้ยกเว้นทุกเงื่อนไขของประเภทลา',
    choices: [
      {
        value: true,
        title: 'อนุญาต',
        description:
          'พนักงานสามารถใช้ตัวเลือกฉุกเฉินตามที่ระบบรองรับ โดยยังตรวจวันที่ จำนวนครั้ง ระยะเวลา และเงื่อนไขอื่น'
      },
      {
        value: false,
        title: 'ไม่อนุญาต',
        description: 'ไม่เปิดการใช้ตัวเลือกฉุกเฉินสำหรับประเภทลานี้'
      }
    ]
  },
  inMonthCondition: {
    summary:
      'จำกัดเดือนที่ขอลาได้ตามวันเกิดที่บันทึกในข้อมูลพนักงานหรือครอบครัว',
    choices: [
      {
        value: 1,
        title: 'ไม่จำกัดเดือนเกิด',
        description: 'ไม่ใช้เงื่อนไขเดือนเกิด'
      },
      {
        value: 2,
        title: 'เดือนเกิดพนักงาน',
        description: 'ลาได้ในเดือนเกิดของพนักงาน',
        example: 'เกิดเดือนพฤษภาคม เลือกลาในเดือนพฤษภาคม'
      },
      {
        value: 3,
        title: 'เดือนเกิดคู่สมรส',
        description: 'ลาได้ในเดือนเกิดคู่สมรสตามข้อมูลครอบครัว'
      },
      {
        value: 4,
        title: 'เดือนเกิดบุตร',
        description:
          'ลาได้ในเดือนเกิดบุตรตามข้อมูลครอบครัว หากมีหลายคนใช้เดือนเกิดที่ระบบบันทึกไว้'
      }
    ]
  },
  payment: {
    summary:
      'กำหนดว่าการลาประเภทนี้ได้รับค่าจ้างหรือไม่ และได้รับค่าจ้างสูงสุดนานเท่าใด',
    choices: [
      {
        value: false,
        title: 'ไม่จ่าย',
        description: 'กำหนดให้การลาประเภทนี้เป็นการลาโดยไม่ได้รับค่าจ้าง'
      },
      {
        value: true,
        title: 'จ่าย',
        description: 'กำหนดระยะเวลาลาที่ได้รับค่าจ้างในช่องถัดไป'
      }
    ]
  },
  paymentDuration: {
    summary: 'กรอกระยะเวลาสูงสุดที่ได้รับค่าจ้างและเลือกหน่วย เช่น 30 วัน',
    choices: [
      {
        value: 1,
        title: 'วัน',
        description: 'ระบุระยะเวลาลาที่ได้รับค่าจ้างเป็นวัน'
      },
      {
        value: 2,
        title: 'ชั่วโมง',
        description: 'ระบุระยะเวลาลาที่ได้รับค่าจ้างเป็นชั่วโมง'
      },
      {
        value: 3,
        title: 'นาที',
        description: 'ระบุระยะเวลาลาที่ได้รับค่าจ้างเป็นนาที'
      }
    ]
  },
  leavePeriod: {
    summary:
      'กำหนดรอบวันที่ของสิทธิ์ลา ใช้ร่วมกับการให้สิทธิ์ตามรอบ ไม่ใช่ช่วงห้ามลา',
    choices: [
      {
        value: 1,
        title: 'ตามปฏิทิน',
        description: 'รอบ 1 มกราคมถึง 31 ธันวาคม ระบบกำหนดวันเริ่มและสิ้นสุดให้'
      },
      {
        value: 2,
        title: 'กำหนดเอง',
        description:
          'เลือกวันและเดือนเริ่มรอบ ระบบกำหนดวันสิ้นสุดเป็นวันก่อนเริ่มรอบถัดไป',
        example: 'เริ่ม 1 เมษายน สิ้นสุด 31 มีนาคมของปีถัดไป'
      }
    ]
  },
  leavePeriodDates: {
    summary:
      'วัน/เดือนซ้ายคือวันเริ่มรอบ ขวาคือวันสิ้นสุดที่ระบบคำนวณให้ รอบปฏิทินแก้ไม่ได้ รอบกำหนดเองแก้ได้เฉพาะวันเริ่ม'
  },
  order: {
    summary: 'เลขลำดับที่ใช้เรียงประเภทลาในการแสดงผล'
  },
  approveWorkflow: {
    summary:
      'เลือก Workflow ที่กำหนดสายและลำดับผู้อนุมัติสำหรับคำขอลาประเภทนี้ โดยใช้ Workflow ที่ตั้งค่าไว้แล้ว'
  }
}
